import { render, staticRenderFns } from "./dashboard-header-summary.vue?vue&type=template&id=4259484a"
import script from "./dashboard-header-summary.vue?vue&type=script&lang=js"
export * from "./dashboard-header-summary.vue?vue&type=script&lang=js"
import style0 from "./dashboard-header-summary.vue?vue&type=style&index=0&id=4259484a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports